module.exports = __webpack_public_path__ + "static/media/gear-fill.f8919205.svg";